export const visit = (vm, at) => {
vm(require("foundations-components/lang/bg.lyaml"));
at({ "bg": { "placeholder": "k\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440" } });
};